import React from 'react';
// @ts-ignore
import NoResults from '../../assets/img/No_Favorite_Skills.svg';
import './no-search-results.scss';

const NoSearchResults = (props: any) => {
    const { mainText, countValue, forFilterPanel } = props;
    const baseClassName = 'no-search-results';
    const facetCountCondition = countValue === 0;
    const message1 = facetCountCondition ? 'No results found.' : mainText;
    const message2 = facetCountCondition
        ? 'Broaden your selection or reset filters to see more options.'
        : 'Try modifying the search criteria.';
    return (
        <div className={`${baseClassName}`}>
            <div className={`${baseClassName}__header`}>
                <div className={`${baseClassName}__header-icon`}>
                    {(countValue > 0 || !forFilterPanel) && (
                        <img
                            id="no-search-results-logo"
                            src={NoResults}
                            alt="no search results Logo"
                            className={`${baseClassName}__icon`}
                        />
                    )}
                </div>
                <div className={`${baseClassName}__message`}>
                    <div className={`${baseClassName}__message-body`}>
                        {message1}
                        <div
                            className={`${baseClassName}__message-body-subtext`}
                        >
                            {message2}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NoSearchResults;
